enum StepNames {
  Recipients = "recipients",
  Message = "message",
  Confirm = "confirm",
}

export default StepNames
